/**
 * Названия и цвета компаний-инициаторов (smart-remont-dev).
 */
export const SMART_REMONT_INITIATOR_LABELS = {
  1: "Smart Remont",
  3: "Smart Remont Ltd.",
  6: "Smart Remont South",
  7: "Smart Remont Azure",
  8: "Smart Remont North",
  9: "Smart Remont Viva",
};

export const SMART_REMONT_INITIATOR_NAME_ALIASES = {
  "ТОО «Smart Remont»": "Smart Remont",
  "Smart Remont": "Smart Remont",
  "ЧК Smart Remont Ltd.": "Smart Remont Ltd.",
  "ТОО Smart Remont South": "Smart Remont South",
  "Smart Remont South": "Smart Remont South",
  "ТОО Smart Remont Azure": "Smart Remont Azure",
  "Smart Remont Azure": "Smart Remont Azure",
  "ТОО Smart Remont North": "Smart Remont North",
  "Smart Remont North": "Smart Remont North",
  "ТОО Smart Remont Viva": "Smart Remont Viva",
  "Smart Remont Viva": "Smart Remont Viva",
};

const COMPANY_THEMES = {
  base: { bg: "#e3f2fd", color: "#0d47a1", border: "#64b5f6", accent: "#1976d2" },
  south: { bg: "#e8f5e9", color: "#1b5e20", border: "#81c784", accent: "#388e3c" },
  azure: { bg: "#e1f5fe", color: "#01579b", border: "#4fc3f7", accent: "#0288d1" },
  north: { bg: "#ede7f6", color: "#4527a0", border: "#b39ddb", accent: "#5e35b1" },
  viva: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d", accent: "#f57c00" },
  ltd: { bg: "#e0f2f1", color: "#004d40", border: "#4db6ac", accent: "#00897b" },
  fulfillment: { bg: "#efebe9", color: "#4e342e", border: "#a1887f", accent: "#6d4c41" },
  interiors: { bg: "#fce4ec", color: "#880e4f", border: "#f48fb1", accent: "#c2185b" },
  default: { bg: "#f5f5f5", color: "#424242", border: "#bdbdbd", accent: "#757575" },
};

const INITIATOR_COMPANY_THEME_BY_ID = {
  1: "base",
  3: "ltd",
  6: "south",
  7: "azure",
  8: "north",
  9: "viva",
};

const LABEL_THEME_RULES = [
  { pattern: /\bsouth\b/i, theme: "south" },
  { pattern: /\bazure\b/i, theme: "azure" },
  { pattern: /\bnorth\b/i, theme: "north" },
  { pattern: /\bviva\b/i, theme: "viva" },
  { pattern: /\bltd\b/i, theme: "ltd" },
  { pattern: /\bfulfillment\b/i, theme: "fulfillment" },
  { pattern: /\binteriors\b/i, theme: "interiors" },
  { pattern: /^smart remont$/i, theme: "base" },
];

export const isSmartRemontInitiatorName = (name = "") =>
  /smart\s*remont/i.test(name);

const resolveCompanyInput = (companyOrName, initiatorCompanyId) => {
  if (companyOrName && typeof companyOrName === "object") {
    return {
      id: companyOrName.initiator_company_id,
      name: companyOrName.initiator_company_name,
    };
  }
  return { id: initiatorCompanyId, name: companyOrName };
};

export const getInitiatorCompanyLabel = (companyOrName, initiatorCompanyId) => {
  const { id, name } = resolveCompanyInput(companyOrName, initiatorCompanyId);

  if (id && SMART_REMONT_INITIATOR_LABELS[id]) {
    return SMART_REMONT_INITIATOR_LABELS[id];
  }

  const trimmed = (name || "").trim();
  if (!trimmed) return "";

  if (SMART_REMONT_INITIATOR_NAME_ALIASES[trimmed]) {
    return SMART_REMONT_INITIATOR_NAME_ALIASES[trimmed];
  }

  if (!isSmartRemontInitiatorName(trimmed)) {
    return trimmed;
  }

  return trimmed
    .replace(/^ТОО\s+/i, "")
    .replace(/^ЧК\s+/i, "")
    .replace(/[«»]/g, "")
    .trim();
};

export const getInitiatorCompanyThemeKey = (companyOrName, initiatorCompanyId) => {
  const { id, name } = resolveCompanyInput(companyOrName, initiatorCompanyId);

  if (id && INITIATOR_COMPANY_THEME_BY_ID[id]) {
    return INITIATOR_COMPANY_THEME_BY_ID[id];
  }

  const label = getInitiatorCompanyLabel(companyOrName, initiatorCompanyId);
  const source = `${label} ${name || ""}`;

  for (const rule of LABEL_THEME_RULES) {
    if (rule.pattern.test(source)) {
      return rule.theme;
    }
  }

  if (isSmartRemontInitiatorName(source)) {
    return "base";
  }

  return "default";
};

export const getInitiatorCompanyTheme = (companyOrName, initiatorCompanyId) => {
  const key = getInitiatorCompanyThemeKey(companyOrName, initiatorCompanyId);
  return COMPANY_THEMES[key] || COMPANY_THEMES.default;
};

export const getInitiatorCompanyBadgeStyle = (companyOrName, initiatorCompanyId) => {
  const theme = getInitiatorCompanyTheme(companyOrName, initiatorCompanyId);
  return {
    backgroundColor: theme.bg,
    color: theme.color,
    borderColor: theme.border,
  };
};

export const getInitiatorCompanyAccentStyle = (companyOrName, initiatorCompanyId) => {
  const theme = getInitiatorCompanyTheme(companyOrName, initiatorCompanyId);
  return {
    borderColor: theme.accent,
    background: `linear-gradient(90deg, ${theme.bg} 0%, #fffef8 100%)`,
    boxShadow: `0 4px 16px ${theme.border}66`,
  };
};

export const mapInitiatorCompanyOptions = (companies = []) =>
  companies.map((company) => ({
    ...company,
    initiator_company_name: getInitiatorCompanyLabel(company),
  }));
